module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"users":{"advisor_classification":{"asset_managers":"Vermögensverwalter","banks":"Bankberater","banks_institutional":"Berater Institutionelles Banking","fee_only_financial_advisor":"Honorarberater","financial_broker":"Finanzmakler"}}}}}}')
  delete Component.options._Ctor
}
